import BankTemplatesList from './views/BankTemplatesList.vue'
import BankTemplateStudio from './views/BankTemplateStudio.vue'
import BankTemplateDocumentation from './views/BankTemplateDocumentation.vue'

export const BankTemplatesRoutes = [
  {
    path: '/bank-templates',
    name: 'ListBankTemplates',
    component: BankTemplatesList,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'bank_template:list'
    }
  },
  {
    path: '/bank-template',
    name: 'CreateBankTemplate',
    component: BankTemplateStudio,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'bank_template:create'
    }
  },
  {
    path: '/bank-template-documentation',
    name: 'BankTemplateDocumentation',
    component: BankTemplateDocumentation,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'bank_template:list'
    }
  },
  {
    path: '/bank-template/:id',
    name: 'UpdateBankTemplate',
    component: BankTemplateStudio,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'bank_template:update'
    }
  }
]
